import { render } from "./ControlWrapper.vue?vue&type=template&id=a37c8a62&ts=true"
import script from "./ControlWrapper.vue?vue&type=script&lang=ts"
export * from "./ControlWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__